import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberKey, getMembersKey } from '../../utils/keys';
import { getAuthTokensKey, getAuthMemberKey, } from '../../utils/keys/authToken.keys';
import { useAuthMember } from '../auth/useAuthMember';
export const useUpdateMember = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const { data: authMember } = useAuthMember();
    return useMutation((input) => client.members.update(input, fields), {
        onMutate: async (newMember) => {
            const memberKey = getMemberKey({ id: newMember.id });
            await queryClient.cancelQueries(memberKey);
            const snapshot = queryClient.getQueryData(memberKey);
            queryClient.setQueriesData(memberKey, old => ({
                ...old,
                ...newMember,
            }));
            return { snapshot };
        },
        onSuccess: (updatedMember, vars, context) => {
            var _a;
            const memberKey = getMemberKey({ id: updatedMember.id });
            queryClient.setQueryData(memberKey, oldMember => ({
                ...oldMember,
                ...updatedMember,
            }));
            if (authMember.id === updatedMember.id) {
                queryClient.invalidateQueries(getAuthMemberKey());
            }
            (_a = useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onSuccess) === null || _a === void 0 ? void 0 : _a.call(useMutationOptions, updatedMember, vars, context);
        },
        onError: (err, newMember, context) => {
            var _a;
            const memberKey = getMemberKey({ id: newMember.id });
            queryClient.setQueryData(memberKey, context.snapshot);
            queryClient.invalidateQueries(memberKey);
            (_a = useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onError) === null || _a === void 0 ? void 0 : _a.call(useMutationOptions, err, newMember, context);
        },
        onSettled: () => {
            const membersKey = getMembersKey();
            const authTokenKey = getAuthTokensKey();
            queryClient.invalidateQueries(membersKey);
            queryClient.invalidateQueries(authTokenKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateMember.js.map